import { PortfolioPage } from './pages/portfolio/PortfolioPage';

export default function App() {
  return <PortfolioPage />;
}
